// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"95":"787757da","178":"ae4b3aab","291":"9688574b"}[chunkId] + ".chunk.css";
};